import { FastCalculationForm } from "./forms/FastCalculationForm";
import { UserDetailsForm } from "./forms/UserDetailsForm";
import {TravelVerificationForm} from "./forms/VerificationForm";



export const forms: any = {
    "travelTarifficationStep": FastCalculationForm,
    'travelGeneralContractStep': UserDetailsForm,
    'travelDataVerificationStep': TravelVerificationForm
};